import drugsIcon from 'src/public/img/icon-drugs.svg';
import suicideIcon from 'src/public/img/icon-grave.svg';
import helpIcon from 'src/public/img/icon-help.svg';
import lgbtIcon from 'src/public/img/icon-lgbtq.svg';
import phoneIcon from 'src/public/img/icon-phone.svg';
import psychologicalIcon from 'src/public/img/icon-psychological-help.svg';
import veteransIcon from 'src/public/img/icon-veterans.svg';
import pfaIcon from 'src/public/img/psychological-first-aid.svg';

import { ProgramEnum, ProgramWeekEnum } from '../../models/programs';
import { AdditionalSupportStep } from '../stepComponents/AdditionalSupportStep';
import { CommonReactionsSecondStep } from '../stepComponents/CommonReactionsSecondStep';
import { CommonReactionsStep } from '../stepComponents/CommonReactionsStep';
import { GettingSupportStep } from '../stepComponents/GettingSupportStep';
import { ProgramOverviewStep } from '../stepComponents/ProgramOverviewStep';
import { RelaxationsStrategiesStep } from '../stepComponents/RelaxationStrategiesStep';
import { WhatDoesNotHelpStep } from '../stepComponents/WhatDoesNotHelp';
import { WhatHelpsStep } from '../stepComponents/WhatHelpsStep';
import { PFAProgramState, PFAProgramStep, PFAProgramStepProps } from './pfaProgram';

export const pfaProgramStepsProps: PFAProgramStepProps[] = [
    {
        id: PFAProgramStep.ProgramOverviewStep,
        component: ProgramOverviewStep,
        tooltip: 'Program Overview',
    },
    {
        id: PFAProgramStep.CommonReactionsStep,
        component: CommonReactionsStep,
        tooltip: 'Common Reactions You Might Experience',
        flexGrow: false,
    },
    {
        id: PFAProgramStep.CommonReactionsSecondStep,
        component: CommonReactionsSecondStep,
        tooltip: 'Common Reactions You Might Experience',
        flexGrow: false,
    },
    {
        id: PFAProgramStep.WhatHelpsStep,
        component: WhatHelpsStep,
        tooltip: 'What Helps?',
    },
    {
        id: PFAProgramStep.WhatDoesNotHelpStep,
        component: WhatDoesNotHelpStep,
        tooltip: `What Doesn't Help?`,
    },
    {
        id: PFAProgramStep.GettingSupportStep,
        component: GettingSupportStep,
        tooltip: 'Getting Support',
        flexGrow: false,
    },
    {
        id: PFAProgramStep.RelaxationStrategiesStep,
        component: RelaxationsStrategiesStep,
        tooltip: 'Relaxation Strategies',
        flexGrow: false,
    },
    {
        id: PFAProgramStep.AdditionalSupportStep,
        component: AdditionalSupportStep,
        tooltip: `Additional Support`,
    },
];

export const pfaProgramWeekData = {
    id: ProgramWeekEnum.WeekOne,
    title: 'Psychological First Aid',
    iconUrl: pfaIcon,
    weekNumber: 0,
    readableWeekNumber: 1,
    steps: [
        PFAProgramStep.ProgramOverviewStep,
        PFAProgramStep.CommonReactionsStep,
        PFAProgramStep.CommonReactionsSecondStep,
        PFAProgramStep.GettingSupportStep,
        PFAProgramStep.WhatHelpsStep,
        PFAProgramStep.WhatDoesNotHelpStep,
        PFAProgramStep.RelaxationStrategiesStep,
        PFAProgramStep.AdditionalSupportStep,
    ],
    stepsProps: pfaProgramStepsProps,
    isUnlocked: true,
    isStarted: false,
    isCompleted: false,
};

export const pfaProgramDefaultState: PFAProgramState = {
    id: ProgramEnum.PFA,
    title: 'Psychological First Aid',
    iconUrl: pfaIcon,
    weeks: [pfaProgramWeekData],
};

export const unitedStatesResources = [
    {
        topic: 'Suicide',
        icon: suicideIcon,
        content: ['1800 784-2433', '1800 799-4889 (TTY/TDD)'],
        websites: ['http://suicide.org'],
    },
    {
        topic: 'Alcohol/Drugs',
        icon: drugsIcon,
        websites: ['https://al-anon.org/', 'https://www.aa.org/', 'https://www.na.org/'],
    },
    {
        topic: 'Veterans',
        icon: veteransIcon,
        websites: ['https://www.veteranscrisisline.net/'],
    },
    {
        topic: 'LGBTQ+',
        icon: lgbtIcon,
        content: ['1866 488-7386'],
        websites: ['https://www.thetrevorproject.org/get-help-now/'],
    },
];

export const internationalResources = [
    {
        topic: 'List of International Suicide Hotlines',
        icon: suicideIcon,
        websites: ['http://www.suicide.org/international-suicide-hotlines.html'],
    },
    {
        topic: 'List of International Helplines',
        icon: helpIcon,
        websites: ['http://togetherweare-strong.tumblr.com/helpline'],
    },
    {
        topic: 'Volunteer Phone/Email Resources',
        icon: phoneIcon,
        websites: ['https://www.befrienders.org/help-and-support'],
    },
];

export const otherResources = [
    {
        topic: 'Psychological First Aid - National Center',
        icon: psychologicalIcon,
        websites: ['http://www.suicide.org/international-suicide-hotlines.html'],
    },
];
